// initial state

const state = {
//   signedIn: false,
  user: null
}

// getters
const getters = {
    user(state) {
        return state.user
    },
    userSignedIn(state) {
        return state.user //returns false if user null.
    },
    userName(state) {
        return state.user.username
    },
    userGroups(state) {
        if (state.user){
            return state.user.signInUserSession.accessToken.payload['cognito:groups']
        } else {
            return null
        }
    },
    userApplications(state){
        var applications = {
            // home:'Echo Ops Portal Home'
        }

        var groupApplications = {
            // Home:'Echo Ops Portal Home',
            Cmdb :'Cmdb',
            IPMan : 'IP Manager',
        }
        const groupAppEntries = Object.entries(groupApplications)

        var cognitoGroups=null

        if (state.user){
            cognitoGroups = state.user.signInUserSession.accessToken.payload['cognito:groups']
            if (cognitoGroups){
                cognitoGroups = cognitoGroups.map(function(x){ return x.toLowerCase() })
                for (const [group, application] of groupAppEntries) {
                    if (cognitoGroups.includes(group.toLowerCase()+"_prod_read") 
                        || cognitoGroups.includes(group.toLowerCase()+"_dev_read")
                        ){
                        //applications.push(application)
                        applications['/'+group.toLowerCase()] =application+' (Read Access)' 
                    } else if (cognitoGroups.includes(group.toLowerCase()+"_prod_admin")
                        || cognitoGroups.includes(group.toLowerCase()+"_dev_admin")
                        ){
                    //applications.push(application)
                    applications['/'+group.toLowerCase()] =application+' (Full Access)' 
                    }
                }    
            }
            applications['/home'] ='Ops Portal Home'          
        }
        // console.log(applications)
        return (applications)
    },
    userIdJwtToken(state){
        var idJwtToken =null
        if(state.user){
            idJwtToken = state.user.signInUserSession.idToken.jwtToken //for userpool authoriser
        }
        return idJwtToken   
    },
    userAccessJwtToken(state){
        var accessJwtToken = null
        if(state.user){
            accessJwtToken = state.user.signInUserSession.accessToken.jwtToken
        }
        return accessJwtTokenaccessJwtToken
    },
}

// actions
const actions = {
    setUser ({commit}, user) {
        commit('setUser', user)
    }
}

// mutations
const mutations = {
    setUser (state, user) {
        state.user = user
        // state.signedIn=true
    }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}